module.exports = __webpack_public_path__ + "files/a7527401354e61ff6a7900c2f98bd2fe.svg";